import { transparentize } from 'polished';
import c from '../colors';
/**
 * @see http://livingston.sas.com/10-0/essentials/status/
 */
export const stateStatus = {
  alert(theme) {
    switch (theme.baseReportThemeName) {
      case 'highcontrast2018':
      case 'highcontrast2017':
        return {
          fg: c.a(theme),
          bg: c.black(theme),
          bd: c.a(theme)
        };
    }
    switch (theme.baseThemeName) {
      case 'dark':
        return {
          fg: c.a1(theme),
          bg: c.p_3(theme),
          bd: c.a1(theme)
        };
      case 'high-contrast':
        return {
          fg: c.a1_5(theme),
          bg: c.black(theme),
          bd: c.a1_5(theme)
        };
      default:
        return {
          fg: c.a(theme),
          bg: c.white(theme),
          bd: c.a(theme)
        };
    }
  },
  warning(theme) {
    switch (theme.baseReportThemeName) {
      case 'highcontrast2018':
      case 'highcontrast2017':
        return {
          fg: c.w(theme),
          bg: c.black(theme),
          bd: c.w(theme)
        };
    }
    switch (theme.baseThemeName) {
      case 'dark':
        return {
          fg: c.white(theme),
          bg: c.p_3(theme),
          bd: c.w1(theme)
        };
      case 'high-contrast':
        return {
          fg: c.w1_5(theme),
          bg: c.black(theme),
          bd: c.w1_5(theme)
        };
      default:
        return {
          fg: c.n_2(theme),
          bg: c.white(theme),
          bd: c.w(theme)
        };
    }
  },
  success(theme) {
    switch (theme.baseReportThemeName) {
      case 'highcontrast2018':
      case 'highcontrast2017':
        return {
          fg: c.s(theme),
          bg: c.black(theme),
          bd: c.s(theme)
        };
    }
    switch (theme.baseThemeName) {
      case 'dark':
        return {
          fg: c.white(theme),
          bg: c.p_3(theme),
          bd: c.s1(theme)
        };
      case 'high-contrast':
        return {
          fg: c.s1_5(theme),
          bg: c.black(theme),
          bd: c.s1_5(theme)
        };
      default:
        return {
          fg: c.n_2(theme),
          bg: c.white(theme),
          bd: c.s(theme)
        };
    }
  },
  informational(theme) {
    switch (theme.baseReportThemeName) {
      case 'highcontrast2018':
      case 'highcontrast2017':
        return {
          fg: c.i(theme),
          bg: c.black(theme),
          bd: c.i(theme)
        };
    }
    switch (theme.baseThemeName) {
      case 'dark':
        return {
          fg: c.white(theme),
          bg: c.p_3(theme),
          bd: c.i1(theme)
        };
      case 'high-contrast':
        return {
          fg: c.i1_5(theme),
          bg: c.black(theme),
          bd: c.i1_5(theme)
        };
      default:
        return {
          fg: c.n_2(theme),
          bg: c.white(theme),
          bd: c.i(theme)
        };
    }
  }
};

/**
 * @see http://livingston.sas.com/10-0/essentials/status/
 */
export const stateStatusPadBox = {
  alert(theme) {
    switch (theme.baseReportThemeName) {
      case 'highcontrast2018':
      case 'highcontrast2017':
        return {
          fg: c.white(theme),
          bg: c.a(theme)
        };
    }
    switch (theme.baseThemeName) {
      case 'dark':
        return {
          // TODO: I think livingston has an inconsistency here. I think this SHOULD BE white.
          // TODO: merge request: https://gitlab.sas.com/visualdesign/livingston_10/merge_requests/4
          fg: c.white(theme),
          bg: transparentize(0.8, c.a1(theme))
        };
      case 'high-contrast':
        return {
          fg: c.black(theme),
          bg: c.a1_5(theme)
        };
      default:
        return {
          fg: c.n_2(theme),
          bg: c.a2(theme)
        };
    }
  },
  warning(theme) {
    switch (theme.baseReportThemeName) {
      case 'highcontrast2018':
      case 'highcontrast2017':
        return {
          fg: c.white(theme),
          bg: c.w(theme)
        };
    }
    switch (theme.baseThemeName) {
      case 'dark':
        return {
          fg: c.white(theme),
          bg: transparentize(0.8, c.w1(theme))
        };
      case 'high-contrast':
        return {
          fg: c.black(theme),
          bg: c.w1_5(theme)
        };
      default:
        return {
          fg: c.n_2(theme),
          bg: c.w2(theme)
        };
    }
  },
  success(theme) {
    switch (theme.baseReportThemeName) {
      case 'highcontrast2018':
      case 'highcontrast2017':
        return {
          fg: c.white(theme),
          bg: c.s(theme)
        };
    }
    switch (theme.baseThemeName) {
      case 'dark':
        return {
          fg: c.white(theme),
          bg: transparentize(0.8, c.s1(theme))
        };
      case 'high-contrast':
        return {
          fg: c.black(theme),
          bg: c.s1_5(theme)
        };
      default:
        return {
          fg: c.n_2(theme),
          bg: c.s2(theme)
        };
    }
  },
  informational(theme) {
    switch (theme.baseReportThemeName) {
      case 'highcontrast2018':
      case 'highcontrast2017':
        return {
          fg: c.white(theme),
          bg: c.i(theme)
        };
    }
    switch (theme.baseThemeName) {
      case 'dark':
        return {
          fg: c.white(theme),
          bg: transparentize(0.8, c.i1(theme))
        };
      case 'high-contrast':
        return {
          fg: c.black(theme),
          bg: c.i1_5(theme)
        };
      default:
        return {
          fg: c.n_2(theme),
          bg: c.i2(theme)
        };
    }
  }
};

/**
 * @see http://livingston.sas.com/10-0/essentials/status/
 */
export const stateStatusContent = {
  alert(theme) {
    switch (theme.baseReportThemeName) {
      case 'highcontrast2018':
      case 'highcontrast2017':
        return {
          fg: c.a(theme)
        };
    }
    switch (theme.baseThemeName) {
      case 'dark':
        return {
          fg: c.a1(theme)
        };
      case 'high-contrast':
        return {
          fg: c.a1_5(theme)
        };
      default:
        return {
          fg: c.a(theme)
        };
    }
  },
  warning(theme) {
    switch (theme.baseReportThemeName) {
      case 'highcontrast2018':
      case 'highcontrast2017':
        return {
          fg: c.w(theme)
        };
    }
    switch (theme.baseThemeName) {
      case 'dark':
        return {
          fg: c.w1(theme)
        };
      case 'high-contrast':
        return {
          fg: c.w1_5(theme)
        };
      default:
        return {
          fg: c.w(theme)
        };
    }
  },
  success(theme) {
    switch (theme.baseReportThemeName) {
      case 'highcontrast2018':
      case 'highcontrast2017':
        return {
          fg: c.s(theme)
        };
    }
    switch (theme.baseThemeName) {
      case 'dark':
        return {
          fg: c.s1(theme)
        };
      case 'high-contrast':
        return {
          fg: c.s1_5(theme)
        };
      default:
        return {
          fg: c.s(theme)
        };
    }
  },
  informational(theme) {
    switch (theme.baseReportThemeName) {
      case 'highcontrast2018':
      case 'highcontrast2017':
        return {
          fg: c.i(theme)
        };
    }
    switch (theme.baseThemeName) {
      case 'dark':
        return {
          fg: c.i1(theme)
        };
      case 'high-contrast':
        return {
          fg: c.i1_5(theme)
        };
      default:
        return {
          fg: c.i(theme)
        };
    }
  }
};
export const stateStatusNova = {
  alert(theme) {
    return {
      fg: c.colorAlert(theme),
      bg: c.colorUiLight(theme),
      bd: c.colorAlert(theme)
    };
  },
  warning(theme) {
    return {
      fg: c.colorWarning(theme),
      bg: c.colorUiLight(theme),
      bd: c.colorWarning(theme)
    };
  },
  success(theme) {
    return {
      fg: c.colorSuccess(theme),
      bg: c.colorUiLight(theme),
      bd: c.colorSuccess(theme)
    };
  },
  informational(theme) {
    return {
      fg: c.colorInfo(theme),
      bg: c.colorUiLight(theme),
      bd: c.colorInfo(theme)
    };
  }
};
export const stateStatusPadBoxNova = {
  alert(theme) {
    switch (theme.baseThemeName) {
      case 'dark':
        return {
          fg: c.colorTextDefault(theme),
          bg: c.colorUiMedium(theme)
        };
      case 'high-contrast':
      default:
        return {
          fg: c.colorTextDefault(theme),
          bg: c.colorUiLight(theme)
        };
    }
  },
  warning(theme) {
    const sourceTokens = stateStatusPadBoxNova.alert(theme);
    return {
      ...sourceTokens
    };
  }
};
export const stateStatusContentNova = {
  alert(theme) {
    const sourceTokens = stateStatusNova.alert(theme);
    return {
      ...sourceTokens,
      bd: 'transparent',
      bg: 'transparent'
    };
  },
  warning(theme) {
    const sourceTokens = stateStatusNova.warning(theme);
    return {
      ...sourceTokens,
      bd: 'transparent',
      bg: 'transparent'
    };
  },
  success(theme) {
    const sourceTokens = stateStatusNova.success(theme);
    return {
      ...sourceTokens,
      bd: 'transparent',
      bg: 'transparent'
    };
  },
  informational(theme) {
    const sourceTokens = stateStatusNova.informational(theme);
    return {
      ...sourceTokens,
      bd: 'transparent',
      bg: 'transparent'
    };
  }
};
//# sourceMappingURL=status.js.map